import { gql } from 'graphql-request';
import { Match, Switch, createSignal } from 'solid-js';
import tailwindConfig from '../../../tailwind.config';
import { useAppContext } from '../../app-context-provider/app-context-provider';
import { ErrorCatcher } from '../../tools/error-catcher';
import { MenuDesktop } from './menu-desktop/menu-desktop';
import { MenuMobile } from './menu-mobile/menu-mobile';
import { MenuItem } from './menu-types';

const GET_MENUS_QUERY = gql`
    query GetPrimaryMenu($type: [String]) {
        menu: resources(type: $type) {
            content
            key
        }
    }
`;

export const Menu = () => {
    const { createCachedResource, viewport } = useAppContext();

    const [primaryContentData, setPrimaryContentData] = createSignal<MenuItem[]>([] as MenuItem[]);
    const [secondaryMenuContent, setSecondaryMenuContent] = createSignal<MenuItem[]>([] as MenuItem[]);

    const [menuContent] = createCachedResource(GET_MENUS_QUERY, () => ({ type: ['menu'] }), true);

    const setMenuData = () => {
        menuContent()?.menu.forEach((menu: any) => {
            if (menu.content.externalId === 'menus-primary_menu') {
                setPrimaryContentData(menu.content.menu);
            }
            if (menu.content.externalId === 'menus-secondary_menu') {
                setSecondaryMenuContent(menu.content.menu);
            }
        });
    };


    setMenuData();

    const isBigTablet = () => {
        if (viewport.width >= tailwindConfig.theme.extend.screenValues.bigTabletValue) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <ErrorCatcher componentName="Menu">
            <Switch>
                <Match when={isBigTablet()}>
                    <MenuDesktop primaryMenuData={primaryContentData()} secondaryMenuData={secondaryMenuContent()} />
                </Match>
                <Match when={!isBigTablet()}>
                    <MenuMobile primaryMenuData={primaryContentData().concat(secondaryMenuContent())} />
                </Match>
            </Switch>
        </ErrorCatcher>
    );
};
